import React from "react";
import {Logo, LogoTitleAuthFrameHeader} from "peggirkit";
import logoLight from "@/assets/img/eataliano-logo-dark.svg";
import logoDark from "@/assets/img/eataliano-logo-light.svg";
import {useIntl} from "react-intl";

type Props = {
    titleMsgId: string,
};

const AuthenticationPageLogo = ({titleMsgId}: Props) => {
    const intl = useIntl();

    return (
        <LogoTitleAuthFrameHeader
            title={intl.formatMessage({id: titleMsgId})}
            logo={
                <Logo
                    alt={"Eataliano"}
                    src={logoLight}
                    darkSrc={logoDark}
                    width={88}
                    height={64}
                    imgSizingClassname={"h-12 md:h-16 w-auto"}
                />
            }
        />
    );
};

export default AuthenticationPageLogo;